import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import impostoApi from 'app/services/api/impostoApi';
import React from 'react';

const SelectImposto = ({ id, name, label, value, touched, error, onBlur, onChange, required, autoFocus, disabled }) => {
  return (
    <SelectAsyncInput
      id={id}
      autoFocus={autoFocus}
      required={required}
      name={name}
      label={label}
      value={value}
      onChange={(event, valor) => {
        onChange({
          target: {
            id,
            value: valor,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        const aliquota = new Intl.NumberFormat('pt-BR', { style: 'decimal' }).format(option?.aliquota);
        return `${option?.nome} - ${aliquota}%` || '';
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await impostoApi.pesquisar({
          size: 100,
          sort: 'nome',
          page: next,
          q: query,
        });
        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      disabled={disabled}
      fetchOnFocus
    />
  );
};

export default SelectImposto;
